import { getTimeEntries, getProjectProfitability, getChangeOrders, getExpenses, getProfitabilityReport, getProjectTimeEntries, TimeEntryQuery } from '../services/api';
import { PMTimeEntry } from '../types/pm';
import { createKeyedCache } from '@redpanda/utils';

/** 工時記錄：依查詢條件（週、成員、專案、任務）分開快取；抓失敗時顯示空的列表 */
const useTimeEntryCache = createKeyedCache('pm-time-entry-storage', (query: TimeEntryQuery) => getTimeEntries(query).then(r => r.data), [] as PMTimeEntry[]);

export const useTimeEntries = (query: TimeEntryQuery) => {
  const { data, refetch, key } = useTimeEntryCache(query);
  return { entries: data, refetch, key };
};

/** 專案毛利（管理員才抓：傳 null 不抓） */
export const useProfitabilityCache = createKeyedCache('pm-profitability-storage', (projectId: string) => getProjectProfitability(projectId).then(r => r.data));

/** 專案的變更單 */
export const useChangeOrdersCache = createKeyedCache('pm-change-order-storage', (projectId: string) => getChangeOrders(projectId).then(r => r.data));

/** 專案的外部成本（管理員） */
export const useExpensesCache = createKeyedCache('pm-expense-storage', (projectId: string) => getExpenses(projectId).then(r => r.data));

/** 跨專案利潤報表（管理員）：只有一組條件，沿用 keyed cache 的 persist（先顯示上次的數字、背景重抓） */
export const useProfitabilityReportCache = createKeyedCache('pm-profitability-report-storage', (_: 'all') => getProfitabilityReport().then(r => r.data));

/** 專案詳情「工時」分頁：依專案＋頁數快取 */
export const useProjectTimeEntriesCache = createKeyedCache(
  'pm-project-time-storage',
  (query: { projectId: string; page: number }) => getProjectTimeEntries(query.projectId, query.page).then(r => r.data)
);
